import React, { useEffect, useState } from "react";

import { Instant, nativeJs } from "@js-joda/core";
import { IInstantProps } from "components/dashboard/product-template-table/utils/interfaces";
import { formatDataPatternToCalendar } from "components/dashboard/product-template-table/utils/utils";
import { DATE_PATTERN_MINUTES } from "utils/constants";
import { useDisplayTimezone } from "hooks/useTimezone";
import { fmtDatetime } from "utils/time-utils";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";

const InstantComponent = (props: IInstantProps) => {
  const displayTz = useDisplayTimezone();
  const [instant, setInstant] = useState<Instant | undefined>(
    props.value ? Instant.parse(props.value) : undefined
  );
  const [onCalendarFocus, setOnCalendarFocus] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (onCalendarFocus === false && instant !== undefined) {
      props.changeHandler(instant.toString());
    }
  }, [onCalendarFocus]);

  const dateChangeHandler = (date: Date) => {
    if (date) {
      setInstant(Instant.from(nativeJs(date)));
      props.changeHandler(date.toISOString());
    }
  };

  const hasHours = () => {
    let has = true;
    if (props.format) {
      has = props.format.split(" ")[1] !== undefined;
    }
    return has;
  };
  const dateFormat = formatDataPatternToCalendar(props.format ?? DATE_PATTERN_MINUTES)?.split(" ")[0];

  if (props.isInEditMode) {
    return (
      <CalendarWrapper
        hourFormat="24"
        className="w-full"
        value={instant ? new Date(instant.toEpochMilli()) : undefined}
        onChange={dateChangeHandler}
        onFocus={() => setOnCalendarFocus(true)}
        onHide={() => setOnCalendarFocus(false)}
        dateFormat={dateFormat}
        onInput={e => {
          const val = e.target as HTMLInputElement;
          if (!val.value) {
            setInstant(undefined);
            props.changeHandler(undefined);
          }
        }}
        showTime={hasHours()}
      />
    );
  }
  return <div>{fmtDatetime(instant, displayTz, props.format)}</div>;
};

export default InstantComponent;
